import React from "react";
import Loader from "./Loader";
import styled from "styled-components";

const Center = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    height:100%;
    width:100%;
`;

const SplashScreen = () => {
	return <Center>
       <Loader />
    </Center>
};

export default SplashScreen;